/**
 * Mutación manipular/alterar la información del gre.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setGreInformation(state, nextState) {
    state.greInformation = nextState;
}